import { ErrorHandler, Injectable} from '@angular/core';
import { ConsoleErrorsService } from './console-errors.service';


@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {


    constructor(
      protected consoleErrorsService: ConsoleErrorsService,
    ) {}

    handleError(errorToHandle: any): void {
      try {
        this.consoleErrorsService.logError(errorToHandle);
      } catch (error) {
        console.error('Error logging to console errors to server');
      }
    }
}